// extracted by css-extract-rspack-plugin
export default {"divider":"divider-h2vGBu"};